module.exports = __webpack_public_path__ + "media/images/mailer/icon_lock_open-d377f10d3f005d0d042a1ee1dee8284d.png";